var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgTestimonialsBorder(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 56,
    height: 62,
    viewBox: "0 0 56 62",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M50.2129 15.2887L30.5 3.90748C28.953 3.01432 27.0471 3.01432 25.5 3.90748L5.78723 15.2887C4.24023 16.1818 3.28723 17.8325 3.28723 19.6188V42.3812C3.28723 44.1675 4.24023 45.8182 5.78723 46.7113L25.5 58.0925C27.0471 58.9857 28.953 58.9857 30.5 58.0925L50.2129 46.7113C51.7599 45.8182 52.7129 44.1675 52.7129 42.3812V19.6188C52.7129 17.8325 51.7599 16.1818 50.2129 15.2887ZM32 1.30941C29.5248 -0.119655 26.4753 -0.119656 24 1.30941L4.28723 12.6906C1.81202 14.1197 0.287231 16.7607 0.287231 19.6188V42.3812C0.287231 45.2393 1.81202 47.8803 4.28723 49.3094L24 60.6906C26.4753 62.1197 29.5248 62.1197 32 60.6906L51.7129 49.3094C54.1881 47.8803 55.7129 45.2393 55.7129 42.3812V19.6188C55.7129 16.7607 54.1881 14.1197 51.7129 12.6906L32 1.30941Z",
    fill: "#130B43"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgTestimonialsBorder);
export default __webpack_public_path__ + "static/media/testimonials-border.57b272cfd2605750d98812dcaee681a9.svg";
export { ForwardRef as ReactComponent };